// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {stateSetItem, stateAddItem} from '../../actions/areaActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/area/AddEditStateForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, areaConstants, commonConstants} from "../../constants";
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.area.stateTargetItem,
        userValue: state.app.currentUser,
    }
};

const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode === 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title' : values.title,
            'code'  : values.code
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('/area/state', formData).then(list => {
            dispatch(stateAddItem(list.data.lists));
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addState'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title' : values.title,
            'code'  : values.code
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('area/state/'+id, formData).then(editRes => {
            dispatch(stateSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('area/state/'+id).then(areaInfo => {
            dispatch(stateSetItem(areaInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
